import axios from 'axios'

import environment from '@/environment'
import type { AggregateAvailabilityResponse } from '@/features/bidding/types/aggregateAvailability'
import type { AggregateMarket } from '@/features/bidding/types/aggregateSuggestedBid'

const PORTFOLIO_MANAGER_API_URL = environment.services.portfolioManagerApiUrl

export const GET_AGGREGATE_AVAILABILITY_API_ID = 'GET_AGGREGATE_AVAILABILITY'

export type GetAggregateAvailabilityParams = {
  portfolioCode: string
  market: AggregateMarket
  deliveryDay: string
  resourceCategory: string
}

export const getAggregateAvailability = async (
  params: GetAggregateAvailabilityParams,
): Promise<AggregateAvailabilityResponse> =>
  (await axios.get(`${PORTFOLIO_MANAGER_API_URL}/aggregate-bidding/availability`, { params })).data
